var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('ul',{staticClass:"dropdown-ul"},_vm._l((_vm.types),function(item,index){return _c('li',{key:index + 'type',class:{active: _vm.theType[_vm.keyName] === item[_vm.keyName]},on:{"click":function($event){return _vm.chooseDrop(item)}}},[_vm._v(_vm._s(item.name))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a12ef2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dropdown.vue
// module id = null
// module chunks = 